import React from "react"

import {LexicalEditor} from "lexical"
import PopoverMenuOption from "../../../../../popover-menu/popover-menu/menu-option"
import {lexicalChangeHeading} from "../../../../actions/change-heading"
import {lexicalChangeBlock} from "../../../../actions/change-block"
import {lexicalChangeList} from "../../../../actions/change-list"
import PopoverMenuOptionWithSubmenu from "../../../../../popover-menu/popover-menu/option-with-submenu/menu-option-with-submenu"
import {lexicalChangeBanner} from "../../../../actions/change-banner"
import {BannerType} from "../../../banner/banner-plugin"
import {PopoverMenuItemType} from "../../../../../popover-menu/popover-menu/const"

type Props = {
    menuParams: {
        options     : any[]
        editor      : LexicalEditor
        blockType   : any
    }
    hidePopover : callback
}

// const debug = "ToolbarHeadingMenu"
const debug = false

export default function ToolbarHeadingMenu(props:Props) {

    const onClick = (value:any):void => {
        props.hidePopover()

        switch (value) {
            case 'custom-paragraph' :
            case 'h1'               :
            case 'h2'               :
            case 'h3'               :
                lexicalChangeHeading(props.menuParams.editor, value)
                break

            case 'code'             :
            case 'quote'            :
                lexicalChangeBlock(props.menuParams.editor, props.menuParams.blockType, value)
                break

            case BannerType.LIGHT_BLUE  :
            case BannerType.DARK_BLUE   :
            case BannerType.GREEN       :
            case BannerType.YELLOW      :
            case BannerType.ORANGE      :
            case BannerType.RED         :
            case BannerType.MAGENTA     :
            case BannerType.PURPLE      :
            case BannerType.BROWN       :
            case BannerType.GRAY        :
                lexicalChangeBanner(props.menuParams.editor, props.menuParams.blockType, value)
                break

            case 'check'            :
            case 'bullet'           :
            case 'number'           :
                lexicalChangeList(props.menuParams.editor, props.menuParams.blockType, value)
                break

            default                 :
                debug && console.log(debug, 'onClick', value)
        }
    }

    return (
        <div className="ui5-popover-menu icon-fs-16" style={{minWidth:180}}>
            {_.map(props.menuParams.options, (option:any, index:number)=> {
                if (option === 'separator') {
                    return <div key={index} className="separator"/>
                } else if (option.type === PopoverMenuItemType.SUBMENU) {
                    return <PopoverMenuOptionWithSubmenu key                = {'popover_{0}'.f(index)}
                                                         menuClassName      = 'icon-fs-16'
                                                         option             = {option}
                                                         selectedValue      = {props.menuParams.blockType}
                                                         showMenuSelection  = {true}
                                                         onClick            = {onClick}/>
                } else {
                    return <PopoverMenuOption key       = {option.value}
                                              option    = {option}
                                              selected  = {option.value === props.menuParams.blockType}
                                              onClick   = {()=>onClick(option.value)}/>
                }
            })}
        </div>
    )
}